import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    BehavioralCognitiveThumbnailsModule,
    BehavioralCognitiveThumbnailsModuleExports
} from './BehavioralCognitiveThumbnails/BehavioralCognitiveThumbnails.module';
import {
    BehavioralPatternImageModule,
    BehavioralPatternImageModuleExports
} from './BehavioralPatternImage/BehavioralPatternImage.module';
import {
    BehavioralRangesModule,
    BehavioralRangesModuleExports
} from './BehavioralRanges/BehavioralRanges.module';
import { CardsModule, CardsModuleExports } from './Cards/Cards.module';
import { ClientsidePiPagerComponent } from './clientside-pi-pager.component';
import {
    CoachMarkModule,
    CoachMarkModuleExports
} from './CoachMark/CoachMark.module';
import {
    CognitiveAssessmentImageModule,
    CognitiveAssessmentImageModuleExports
} from './CognitiveAssessmentImage/CognitiveAssessmentImage.module';
import {
    DirectivesModule,
    DirectivesModuleExports
} from './Directives/Directives.module';
import {
    DropdownModule,
    DropdownModuleExports
} from './Dropdown/Dropdown.module';
import {
    FiveStarRatingModule,
    FiveStarRatingModuleExports
} from './FiveStarRating/five-star-rating.module';
import {
    FolderSelectModule,
    FolderSelectModuleExports
} from './FolderSelect/FolderSelect.module';
import {
    FolderTreeEntryModule,
    FolderTreeEntryModuleExports
} from './FolderTreeEntry/FolderTreeEntry.module';
import { PIFooterModule } from './Footer/PIFooter.module';
import { ForbiddenPage } from './ForbiddenPage/forbidden-page.component';
import { IconsModule, IconsModuleExports } from './Icons/Icons.module';
import {
    LoadingDotsModule,
    LoadingDotsModuleExports
} from './LoadingDots/LoadingDots.module';
import { ModalModule, ModalModuleExports } from './Modal/Modal.module';
import { ODataPagerModule } from './odata/odata-pager.module';
import { OkapiExports, OkapiModule } from './Okapi/Okapi.module';
import { OldIconModule, OldIconModuleExports } from './OldIcon/OldIcon.module';
import {
    PersonTypeRadioModule,
    PersonTypeRadioModuleExports
} from './PersonTypeRadio/PersonTypeRadio.module';
import { PiPagerResultsSizePickerComponent } from './pi-pager-results-size-picker';
import {
    RadioChoiceModule,
    RadioChoiceModuleExports
} from './RadioChoice/RadioChoice.module';
import { TablePagerComponent } from './TablePager.component';
import { ToggleComponent } from './Toggle.component';
import {
    TogglerWithWarningModule,
    TogglerWithWarningModuleExports
} from './TogglerWithWarning/toggler-with-warning.module';
import { TooltipModule, TooltipModuleExports } from './Tooltip/Tooltip.module';
import {
    UpgradeAccountExports,
    UpgradeAccountModule
} from './upgrade-account/upgrade-account.module';
import {
    WaitingIndicatorModule,
    WaitingIndicatorModuleExports
} from './WaitingIndicator/WaitingIndicator.module';
import {
    WarningTooltipModule,
    WarningTooltipModuleExports
} from './WarningTooltip/warning-tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        OkapiModule,
        IconsModule,
        BehavioralCognitiveThumbnailsModule,
        CognitiveAssessmentImageModule,
        DirectivesModule,
        ModalModule,
        BehavioralPatternImageModule,
        BehavioralRangesModule,
        CoachMarkModule,
        TooltipModule,
        WaitingIndicatorModule,
        LoadingDotsModule,
        OldIconModule,
        DropdownModule,
        RadioChoiceModule,
        PersonTypeRadioModule,
        FolderTreeEntryModule,
        FolderSelectModule,
        CardsModule,
        PIFooterModule,
        FiveStarRatingModule,
        TogglerWithWarningModule,
        WarningTooltipModule,
        UpgradeAccountModule,
        ODataPagerModule
    ],
    exports: [
        ...OkapiExports,
        ...IconsModuleExports,
        ...BehavioralCognitiveThumbnailsModuleExports,
        ...CognitiveAssessmentImageModuleExports,
        ...DirectivesModuleExports,
        ...ModalModuleExports,
        ...BehavioralPatternImageModuleExports,
        ...BehavioralRangesModuleExports,
        ...CoachMarkModuleExports,
        ...TooltipModuleExports,
        ...WaitingIndicatorModuleExports,
        ...LoadingDotsModuleExports,
        ...OldIconModuleExports,
        ...DropdownModuleExports,
        ...RadioChoiceModuleExports,
        ...PersonTypeRadioModuleExports,
        ...FolderTreeEntryModuleExports,
        ...FolderSelectModuleExports,
        ...CardsModuleExports,
        ...FiveStarRatingModuleExports,
        ...TogglerWithWarningModuleExports,
        ...WarningTooltipModuleExports,
        ...UpgradeAccountExports,
        PIFooterModule,
        ToggleComponent,
        TablePagerComponent,
        ClientsidePiPagerComponent,
        PiPagerResultsSizePickerComponent,
        ODataPagerModule
    ],
    declarations: [
        ToggleComponent,
        TablePagerComponent,
        ClientsidePiPagerComponent,
        PiPagerResultsSizePickerComponent,
        ForbiddenPage
    ]
})
export class CoreUiModule {}
